export default __webpack_public_path__ + "assets/a5a7a60691b02a51be7b969f741da7d0.png";